import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { LoginModalProvider } from '../context/LoginModalContext';
import LoginModal from './login/LoginModal';
import { useNotifications } from '../context/NotificationContext';
import { useAnalytics } from '../context/AnalyticsContext';
import { Facebook, Instagram, Linkedin } from 'lucide-react';

const SSR_APP_URL = process.env.REACT_APP_SSR_APP_URL || 'https://aika.camp';

interface FooterProps {
  className?: string;
}

const Footer: React.FC<FooterProps> = ({ className = '' }) => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const { showSuccess } = useNotifications();
  const { trackEvent } = useAnalytics();

  const handleRegister = (email: string) => {
    setShowLoginModal(false);
    showSuccess("You have successfully registered!")
  };

  const handleLogin = (email: string) => {
    setShowLoginModal(false);
    showSuccess("You have successfully logged in!")
  };

  const handleLoginClose = () => {
    setShowLoginModal(false);
  };

  return (
    <footer className={`app-footer ${className}`}>
      <div className="footer-container">
        <div className="footer-main">
          <div className="footer-brand">
            <div className="brand-logo">
              <img src="/images/logo.png" alt="Aika Logo" className="brand-logo-image" />
            </div>
            <p className="brand-description">
              Reducing parents' mental load around the camp and activity search.
            </p>
            <div className="social-icons">
              <a href="https://www.facebook.com/people/Aika-Camp-Planner/61581884717411/" className="social-icon" aria-label="Facebook" target="_blank">
                <Facebook className="icon--secondary icon--md" />
              </a>
              <a href="https://www.instagram.com/aika.camp/" className="social-icon" aria-label="Instagram" target="_blank">
                <Instagram className="icon--secondary icon--md" />
              </a>
              <a href="https://www.linkedin.com/company/aikacamp/" className="social-icon" aria-label="LinkedIn" target="_blank">
                <Linkedin className="icon--secondary icon--md" />
              </a>
            </div>
          </div>

          <div className="footer-nav">
            <div className="footer-column">
              <h4 className="footer-title">Camp Planner</h4>
              <ul className="footer-links">
                <li><a href={`${SSR_APP_URL}/search`} className="footer-link">Find Camps</a></li>
                <li>
                  <button 
                    onClick={() => {
                      setShowLoginModal(true);
                      trackEvent('footer_login_link_clicked', { location: window.location.pathname });
                    }}
                    className="footer-link footer-login-button"
                  >
                    Log In
                  </button>
                </li>
                <li><a href={`${SSR_APP_URL}/partners`} className="footer-link">For Camps</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4 className="footer-title">Company</h4>
              <ul className="footer-links">
                <li><Link to="/about" className="footer-link">Why Aika?</Link></li>
                <li><Link to="/team" className="footer-link">Team</Link></li>
                <li><Link to="/careers" className="footer-link">Careers</Link></li>
                
              </ul>
            </div>

            <div className="footer-column">
              <h4 className="footer-title">Legal</h4>
              <ul className="footer-links">
                <li><Link to="/terms" className="footer-link">Terms of Service</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-divider"></div>

        <div className="footer-bottom">
          <p>© 2025 Aika. Made with ❤️ in Boulder, CO.</p>
        </div>
      </div>

      {showLoginModal && (
        <LoginModalProvider initialStep="email">
          <LoginModal onClose={handleLoginClose} onLogin={handleLogin} onRegister={handleRegister} />
        </LoginModalProvider>
      )}
    </footer>
  );
};

export default Footer;
